<div [formGroup]="form">
  <div class="row">
    <h4 class="col-12">Buletin de Însămânțare Artificială</h4>
  </div>

  <div class="row">
    <div class="col-auto mb-3 w26">
      <label>Operator însămânțare</label>

      <ng-select
        [items]="listaOperatori"
        formControlName="operator_id"
        bindValue="id"
        placeholder="Selectează operator"
        (search)="searchOperator($event)"
        [ngClass]="{
          disabled: disabledFields['operator_id'],
          'is-invalid': field_errors['operator_id']
        }"
        (change)="field_errors['operator_id'] = null"
      >
      </ng-select>
      <div class="text-danger">{{ field_errors["operator_id"] }}</div>
    </div>

    <div class="col-auto mb-3 ml-2">
      <label>Data însămânțare</label>

      <app-date-picker
        [selectedDate]="form.value.data_insamantare"
        (dateChanged)="dataMontaChange($event)"
        [invalid]="field_errors['data_insamantare']"
        [disabled]="disabledFields['data_insamantare']"
      >
      </app-date-picker>
      <div class="text-danger">{{ field_errors["data_insamantare"] }}</div>
    </div>

    <div class="col-auto mb-3 ml-2">
      <label>Număr document</label>

      <input
        type="text"
        formControlName="nr_document"
        placeholder="Introduceți Număr document"
        class="form-control w10"
        [ngClass]="{
          disabled: disabledFields['nr_document'],
          'is-invalid': field_errors['nr_document']
        }"
        (change)="field_errors['nr_document'] = null"
      />
      <div class="text-danger">{{ field_errors["nr_document"] }}</div>
    </div>

    <div class="col-auto ml-2">
      <label>Fișier</label>

      <div *ngIf="form.value.file_name">
        <span
          class="file-button"
          (click)="downloadFile($event)"
        >
          {{ form.value.file_name }}
        </span>

        <button
          *ngIf="!disabledFields['file_id'] && form.value.file_id"
          type="button"
          class="btn btn-lg p-0 ml-2 mdi mdi-delete text-danger"
          ngbTooltip="Șterge fișier"
          placement="right"
          (click)="deleteFile()"
        ></button>
      </div>

      <div *ngIf="!form.value.file_id">
        <app-upload-fisier
          class="ml-3"
          (ApiResponse)="uploadInsamantareArtificiala($event)"
        >
        </app-upload-fisier>
      </div>

      <div class="text-danger">{{ field_errors["file_id"] }}</div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-xl-9 mb-2">
      <label>Taur</label>

      <span
        *ngIf="!disabledFields['taur_id']"
        class="mdi mdi-refresh cursor-pointer text-blue fs-4 ml-1"
        (click)="getListaTauri()"
      >
      </span>

      <div class="d-flex">
        <div class="flex-grow-1">
          <ng-select
            [items]="listaTauri"
            formControlName="taur_id"
            bindValue="id"
            placeholder="Introduceți matricol taur"
            [ngClass]="{
              disabled: disabledFields['taur_id'],
              'is-invalid': field_errors['taur_id']
            }"
            (change)="selectTaur($event)"
          >
            <ng-template ng-label-tmp ng-option-tmp let-item="item">
              <div class="row">
                <div
                  class="col-auto d-flex align-items-center justify-content-center"
                >
                  <div class="box-mascul">M</div>
                  <div class="color-mascul">{{ item["numarmatricol"] }}</div>
                  <div class="ml-2">{{ item["rasa"] }}</div>
                  <div *ngIf="item['codtaur']" class="ml-2">
                    {{ item["codtaur"] }}
                  </div>
                  <div *ngIf="item['nume']" class="ml-2">
                    {{ item["nume"] }}
                  </div>
                </div>

                <div class="col-sm-12 col-md-auto px-0">
                  <span
                    *ngFor="let error of item['errors']"
                    class="badge badge-danger p-1 mr-2"
                  >
                    {{ error }}
                  </span>
                  <span
                    *ngFor="let warning of item['warnings']"
                    class="badge badge-warning text-dark p-1 mr-2"
                  >
                    {{ warning }}
                  </span>
                </div>
              </div>
            </ng-template>
          </ng-select>

          <small
            *ngIf="!disabledFields['taur_id']"
            class="form-text text-muted"
          >
            <div class="mb-2">
              <span>
                Taurul se poate alege după ce s-a ales Data însămânțare
              </span>
            </div>
          </small>

          <div class="text-danger">{{ field_errors["taur_id"] }}</div>
        </div>

        <a
          *ngIf="form.value.taur_id"
          [routerLink]="'/dashboard/animal/' + form.value.taur_id"
          target="_blank"
          class="ml-2 fs-3"
          title="Pagina animalului"
          ><i class="mdi mdi-open-in-new mr-1"></i
        ></a>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-xl-9 mb-2">
      <label>Femelă</label>

      <span
        *ngIf="!disabledFields['femela_id']"
        class="mdi mdi-refresh cursor-pointer text-blue fs-4 ml-1"
        (click)="getListaFemele()"
      >
      </span>

      <div class="d-flex">
        <div class="flex-grow-1">
          <ng-select
            [items]="listaFemele"
            formControlName="femela_id"
            bindValue="id"
            placeholder="Introduceți matricol femelă"
            [ngClass]="{
              disabled: disabledFields['femela_id'],
              'is-invalid': field_errors['femela_id']
            }"
            [closeOnSelect]="true"
            (change)="selectFemela($event)"
          >
            <ng-template ng-label-tmp ng-option-tmp let-item="item">
              <div class="row">
                <div
                  class="col-auto d-flex align-items-center justify-content-center"
                >
                  <div class="box-femela">F</div>
                  <div class="color-femela">{{ item["numarmatricol"] }}</div>
                  <div class="ml-2">{{ item["rasa"] }}</div>
                  <div *ngIf="item['nume']" class="ml-2">
                    {{ item["nume"] }}
                  </div>
                </div>

                <div class="col-sm-12 col-md-auto px-0">
                  <span
                    *ngFor="let error of item['errors']"
                    class="badge badge-danger p-1 mr-2"
                  >
                    {{ error }}
                  </span>
                  <span
                    *ngFor="let warning of item['warnings']"
                    class="badge badge-warning text-dark p-1 mr-2"
                  >
                    {{ warning }}
                  </span>
                </div>
              </div>
            </ng-template>
          </ng-select>

          <small
            *ngIf="!disabledFields['femela_id']"
            class="form-text text-muted"
          >
            <div class="mb-2">
              <span>
                Femela se poate alege după ce s-a ales Data însămânțare și Taur
              </span>
            </div>
          </small>

          <div class="text-danger">{{ field_errors["femela_id"] }}</div>
        </div>

        <a
          *ngIf="form.value.femela_id"
          [routerLink]="'/dashboard/animal/' + form.value.femela_id"
          target="_blank"
          class="ml-2 fs-3"
          title="Pagina animalului"
          ><i class="mdi mdi-open-in-new mr-1"></i
        ></a>
      </div>
    </div>
  </div>
</div>
